// src/components/shared/UpdateBanner.jsx
import React from "react";
import { Alert, Button } from "react-bootstrap";

export default function UpdateBanner({ show, onRefresh, onDismiss }) {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: 12,
        right: 12,
        bottom: 12,
        zIndex: 2000,
      }}
    >
      <Alert variant="warning" className="d-flex align-items-center justify-content-between mb-0">
        <div style={{ paddingRight: 12 }}>
          Υπάρχει νέα έκδοση διαθέσιμη.
        </div>
        <div className="d-flex gap-2">
          <Button size="sm" variant="primary" onClick={onRefresh}>
            Ανανέωση
          </Button>
          <Button size="sm" variant="outline-secondary" onClick={onDismiss}>
            Κλείσιμο
          </Button>
        </div>
      </Alert>
    </div>
  );
}
